export default "__VITE_ASSET__DWHchW7t__"